import { useEffect } from "react";

const SITE = "https://events.hexlabsgames.com";
const NODE_ID = "event-structured-data";

function priceValue(price) {
  const match = /\d+(?:\.\d{1,2})?/.exec(price || "");
  return match ? match[0] : "0";
}

function toEventSchema(event) {
  const start = new Date(event.start);
  const end = new Date(start.getTime() + 3 * 3600 * 1000);
  const schema = {
    "@context": "https://schema.org",
    "@type": "Event",
    name: event.title,
    description: event.description || `${event.game} tournament at Hex Labs Games in Maldon, Essex.`,
    startDate: start.toISOString(),
    endDate: end.toISOString(),
    eventStatus: "https://schema.org/EventScheduled",
    eventAttendanceMode: "https://schema.org/OfflineEventAttendanceMode",
    url: `${SITE}/events`,
    location: {
      "@type": "Place",
      name: "Hex Labs Games",
      address: {
        "@type": "PostalAddress",
        streetAddress: "1a Edward Bright Close",
        addressLocality: "Maldon",
        addressRegion: "Essex",
        postalCode: "CM9 5RU",
        addressCountry: "GB",
      },
    },
    organizer: { "@type": "Organization", name: "Hex Labs Games", url: "https://hexlabsgames.com" },
    performer: { "@type": "Organization", name: "Hex Labs Games" },
  };
  if (event.image_url) {
    schema.image = event.image_url.startsWith("/")
      ? `${process.env.REACT_APP_BACKEND_URL}${event.image_url}`
      : event.image_url;
  }
  if (event.ticket_url) {
    schema.offers = {
      "@type": "Offer",
      url: event.ticket_url,
      price: priceValue(event.price),
      priceCurrency: "GBP",
      availability: event.sold_out ? "https://schema.org/SoldOut" : "https://schema.org/InStock",
      validFrom: new Date().toISOString(),
    };
  }
  return schema;
}

/** Injects schema.org Event data for upcoming events so Google can show dates and prices. */
export function useEventStructuredData(events) {
  useEffect(() => {
    const now = new Date();
    const upcoming = (events || [])
      .filter((e) => new Date(e.start) >= now)
      .sort((a, b) => new Date(a.start) - new Date(b.start))
      .slice(0, 30);
    if (upcoming.length === 0) return undefined;

    const node = document.createElement("script");
    node.type = "application/ld+json";
    node.id = NODE_ID;
    node.textContent = JSON.stringify(upcoming.map(toEventSchema));
    document.getElementById(NODE_ID)?.remove();
    document.head.appendChild(node);
    return () => node.remove();
  }, [events]);
}
